import React, { useState, useEffect } from 'react';

const DURACION_MS = 8000;

// Cartel inferior de "deshacer" para la bandeja de Google Calendar (etapa
// 3c). Vive como hijo flex de .modal-card (ver ModalBandejaGoogle.jsx), no
// position:fixed — así ocupa su propio espacio en el layout del modal en vez
// de flotar encima del último ítem de la lista, y desaparece solo al
// desmontarse el modal. El padre lo remonta con una `key` nueva cada vez que
// se resuelve una acción, así el timer de 8s siempre arranca de cero y solo
// hay un cartel activo a la vez (reemplaza al anterior).
function ToastDeshacer({ mensaje, onDeshacer, onCerrar }) {
  const [estado, setEstado] = useState('activo'); // activo | deshaciendo | error
  const [errorTexto, setErrorTexto] = useState('');

  useEffect(() => {
    if (estado !== 'activo') return;
    const id = setTimeout(onCerrar, DURACION_MS);
    return () => clearTimeout(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [estado]);

  const handleDeshacer = async () => {
    setEstado('deshaciendo');
    try {
      await onDeshacer();
      onCerrar();
    } catch (err) {
      setErrorTexto(
        err.status === 409
          ? 'Ya pasó el tiempo para deshacer esta acción.'
          : 'No se pudo deshacer. Probá de nuevo desde la bandeja.'
      );
      setEstado('error');
      setTimeout(onCerrar, 3000);
    }
  };

  return (
    <div className="toast-deshacer">
      {estado === 'error' ? (
        <span className="toast-deshacer-error">{errorTexto}</span>
      ) : (
        <>
          <span className="toast-deshacer-mensaje">{mensaje}</span>
          <button
            type="button"
            className="toast-deshacer-btn"
            onClick={handleDeshacer}
            disabled={estado === 'deshaciendo'}
          >
            {estado === 'deshaciendo' ? 'Deshaciendo...' : 'Deshacer'}
          </button>
        </>
      )}
    </div>
  );
}

export default ToastDeshacer;
